import { render, staticRenderFns } from "./VMail.vue?vue&type=template&id=53672633&scoped=true"
import script from "./VMail.vue?vue&type=script&lang=js"
export * from "./VMail.vue?vue&type=script&lang=js"
import style0 from "./VMail.vue?vue&type=style&index=0&id=53672633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53672633",
  null
  
)

export default component.exports